<template>
  <div class="wrap">
    <Nav :title="$t('repayDetail.title')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="order_detail">
        <div class="detail_item">
          <div class="label">{{ $t('orderNo') }}:</div>
          <div class="value">{{ loanOrder.loan_no }}</div>
        </div>
        <div class="detail_item">
          <div class="label">{{ $t('loanAmount') }}:</div>
          <div class="value">{{ Number(loanOrder.money || 0) }}</div>
        </div>
        <div class="detail_item">
          <div class="label">{{ $t('terms') }}:</div>
          <div class="value">{{ loanOrder.expect }}</div>
        </div>
        <div class="detail_item">
          <div class="label">{{ $t('accountName') }}:</div>
          <div class="value">{{ userInfo.realname || userInfo.userphone }}</div>
        </div>
        <div class="detail_item">
          <div class="label">{{ $t('applyTime') }}:</div>
          <div class="value">{{ loanOrder.indate && $format(loanOrder.indate, 'dd/MM/yyyy') }}</div>
        </div>
      </div>
      <div class="pend" v-if="loanOrder.status == 0">
        <div class="pend_status">{{ $t('loanPend') }}</div>
      </div>
      <div class="pend" v-if="loanOrder.status == 1">
        <div class="pend_item">
          <div class="label">{{ $t('repayAmount') }}</div>
          <div class="value">{{ pendList.money || 0 }}</div>
        </div>
        <div class="pend_item">
          <div class="label">{{ $t('repayTime') }}</div>
          <div class="value">{{ pendList.indate && $format(pendList.indate, 'dd/MM/yyyy') }}</div>
        </div>
        <!-- <div class="pend_btn">
          <div class="_btn" @click="Repayment">{{ $t('immediateRepay') }}</div>
        </div> -->
      </div>
      <div class="pend" v-if="loanOrder.status == 2">
        <div class="pend_status">{{ $t('allCompleted') }}</div>
      </div>
      <div class="pend" v-if="loanOrder.status == 3">
        <div class="pend_status">{{ $t('applicationRejected') }}</div>
      </div>
      <div class="period" v-if="loanOrder.status == 1 || loanOrder.status == 2">
        <div class="period_item" v-for="item, index in list" :key="index">
          <div class="date">{{ item.indate && $format(item.indate, 'dd/MM/yyyy') }}</div>
          <div class="line">
            <div class="circle"></div>
            <div class="_line"></div>
          </div>
          <div class="info">
            <div class="info_value">{{ item.money }}</div>
            <div class="info_desc">{{ $t('repayAmount') }}</div>
          </div>
          <div class="status" :style="getStyle(item.status)">{{ getStatus(item.status) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast } from "vant";
import Nav from "@/components/Navbar";
import { LOAN_INFO, LOAN_REPAYMENT } from "@/api"
import { mapGetters } from "vuex"
export default {
  components: {
    [Icon.name]: Icon,
    Nav
  },
  data() {
    return {
      loanOrder: {},
      list: [],
      pendList: {},
      isPend: false
    }
  },
  created() {
    this.loanInfo();
    this.$store.dispatch('getUserInfo')
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    async loanInfo() {
      try {
        const res = await LOAN_INFO();
        this.loanOrder = res.data || {}
        this.list = res.data && res.data.order || []
        this.pendList = this.list.length && this.list.find(item => item.status == 0 || item.status == 2)
      } catch (error) { }
    },
    async Repayment() {
      try {
        const res = await LOAN_REPAYMENT();
        this.$toast(res.msg)
        // setTimeout(()=>{
        this.loanInfo();
        this.$store.dispatch('getUserInfo')
        // },2000)
      } catch (error) {
        this.$toast(error.msg)
      }
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return this.$t('pending')
          break;
        case 1:
          return this.$t('completed')
          break;
        case 2:
          return this.$t('overdue')
          break;

        default:
          break;
      }
    },
    getStyle(status) {
      switch (status) {
        case 0:
          return {}
          break;
        case 1:
          return {
            background: '#07c160',
            color: 'var(--white)',
          }
          break;
        case 2:
          return {
            background: '#ee0a24',
            color: 'var(--white)',
          }
          break;

        default:
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: var(--newbg);

  .content {
    padding: calc(15rem / 16) calc(10rem / 16);

    .order_detail {
      background-color: var(--white);

      .detail_item {
        display: flex;
        align-items: center;
        padding: calc(10rem / 16) calc(15rem / 16);
        column-gap: calc(15rem / 16);

        .label,
        .value {
          flex: 1;
        }

        .label {
          color: #999;
          font-size: calc(14rem / 16);
        }

        .value {
          color: #333;
          font-size: calc(16rem / 16);
          text-align: right;
        }
      }
    }

    .pend {
      margin-top: calc(15rem / 16);
      background-color: var(--white);
      padding: calc(15rem / 16);

      &_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: calc(10rem / 16) 0;
        column-gap: calc(15rem / 16);

        .label {
          color: #999;
          font-size: calc(14rem / 16);
        }

        .value {
          color: #333;
          font-size: calc(16rem / 16);
          text-align: right;
        }
      }

      &_btn {
        height: calc(45rem / 16);
        line-height: calc(45rem / 16);
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: calc(20rem / 16);

        ._btn {
          display: inline-block;
          padding: 0 calc(14rem / 16);
          background-color: var(--bg);
          border-radius: calc(50rem / 16);
          color: var(--white);
          font-size: calc(14rem / 16);
        }
      }

      &_status {
        font-size: calc(16rem / 16);
        color: var(--theme);
        text-align: center;
      }
    }

    .period {
      background-color: var(--white);
      margin: calc(15rem / 16) 0;
      padding: calc(20rem / 16) 0 calc(10rem / 16);

      &_item {
        display: flex;
        padding: 0 calc(15rem / 16);
        color: #333;
        justify-content: space-around;

        .date {
          font-size: calc(14rem / 16);
        }

        .line {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 calc(10rem / 16);

          .circle {
            // margin-top: calc(2rem / 16);
            width: calc(8rem / 16);
            height: calc(8rem / 16);
            border: calc(2.5rem / 16) solid #6ca7d9;
            border-radius: 50%;
          }

          ._line {
            width: 1px;
            flex-grow: 1;
            background: #cbc2c2;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          margin-bottom: calc(15rem / 16);

          &_value {
            font-size: calc(14rem / 16);
          }

          &_desc {
            margin-top: calc(5rem / 16);
            font-size: calc(12rem / 16);
            color: #999;
          }
        }

        .status {
          width: calc(60rem / 16);
          height: fit-content;
          font-size: calc(12rem / 16);
          padding: calc(5rem / 16) calc(12rem / 16);
          border-radius: calc(3rem / 16);
          // min-width: calc(45rem / 16);
          text-align: center;
          background: #74747433;
          color: #6a6a6a;
        }
      }

      &_item:last-child {
        .line {
          ._line {
            width: 0;
          }
        }
      }
    }
  }
}
</style>